import React from "react";
import "./styles.css";

import Result from './Result';

import Form from './Form';
import dbUpdate from './dbUpdate'
import EmailBox from './EmailBox'

export default class App extends React.Component{
  constructor(props) {
    super(props);
    let params = new URLSearchParams(window.location.search);
    let id = params.get('id');
    let unsub = Boolean(params.get('unsub'));

    this.state = {
      id : id,
      streamlinedUnsub : unsub,
      unsubscribe : false,
      email : "you@example.com",
      frequency : "",
      emailValidationError: false,
      frequencyValidationError: false,
      
      accepting : true,
      error: false,
    }
    
    this.handleEmailUpdate = this.handleEmailUpdate.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSwitch = this.handleSwitch.bind(this);
    this.handleFrequencyUpdate = this.handleFrequencyUpdate.bind(this);
  }
  
  handleSwitch(event) {
    this.setState({streamlinedUnsub : !this.state.streamlinedUnsub, frequency: ""})
  }
  
  handleEmailUpdate(event) {
    this.setState({email: event.target.value, emailValidationError: false});
  }
  
  handleFrequencyUpdate(event) {
    this.setState({frequency: event.target.value, frequencyValidationError: false});
  }
  
  handleSubmit(event) {
    if (EmailBox.verify(this.state.email)) {
      this.setState({unsubscribe : this.state.streamlinedUnsub}, ()=>{
        if (!this.state.unsubscribe && this.state.frequency !== "") {
         dbUpdate(this.state, (result) => {
            console.log(result)
            if (!result.isError) {
              this.setState({
                accepting : false,
                status: "Success!",
                message: result.message
              })
            } else {
              this.setState({
                accepting : false,
                error: true,
                status: result.statusCode + " - " + result.error,
                message: result.message
              })
            }
            setTimeout(()=>{
              this.setState({
                accepting : true,
                status: "",
                error: false,
                message: ""
              })
            },10000) //Show form again after 10000ms
          });
        } else {
          this.setState({
            frequencyValidationError : true
          })
        }
      });
    } else {
      this.setState({emailValidationError: true,})
    };
    event.preventDefault();
  }
  
  render() {
    if (this.state.accepting) {
      return (
        <div className="App">
          <h1>Hey Listen<a style={{color:"#000", textDecoration: "none"}}href="https://www.youtube.com/watch?v=CZbq64VvVFc">!</a> </h1>
          <h2>So you wanna {this.state.streamlinedUnsub ? "unsubscribe" : "change some email settings"}, huh?</h2>
          <Form 
            handleSwitch={this.handleSwitch} 
            handleEmailUpdate={this.handleEmailUpdate} 
            handleFrequencyUpdate={this.handleFrequencyUpdate} 
            handleSubmit={this.handleSubmit}
            streamlinedUnsub={this.state.streamlinedUnsub}
            email={this.state.email}
            frequency={this.state.frequency}  
            emailValidationError={this.state.emailValidationError}
            frequencyValidationError={this.state.frequencyValidationError}
          />
          <p className="link" onClick={this.handleSwitch}>{this.streamlinedUnsub ? "I'd actually like fewer emails instead" : "I'd actually like to unsubscribe"}</p>
          {/* <br/>
          <Unsub/> */}
          {/* <Error code="501" name="Unimplimented Features" text="Due to time constraints, this feature hasn't been implemented yet. Email me at christensen.joshua@missionary.org"/> */}
          
        </div>
      );
    } else {
      return (
        <div className="App">
          <Result 
            error={this.state.error} 
            status={this.state.status}
            message={this.state.message}
          />
        </div>
      );
    }
  }
}
